const nav = () => {
    const navToggle = document.querySelector('.menu-toggle')
    if (!navToggle) return

    navToggle.addEventListener('click', () => {
        const opened = document.body.classList.toggle('menu-opened')
        navToggle.setAttribute('aria-expanded', String(opened))
    })

    const mobileNav = document.querySelector('.mobile-nav')
    if (!mobileNav) return

    const mobileNavBtns = mobileNav.querySelectorAll('a')
    if (!mobileNavBtns) return

    mobileNavBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            document.body.classList.remove('menu-opened')
            navToggle.setAttribute('aria-expanded', 'false')
        })
    })
}

export default nav
